'use strict';

angular.module('systemOwnerReviewRoutes.DecommissionSystems', ['systemOwnerReviewControllers.DecommissionSystems'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('systemOwnerReview.authUser.decommissionSystems', {
            url: '/DecommissionSystems',
            views: {
                '': {
                    templateUrl: require('./DecommissionSystems.tpl.html'),
                    controller: 'DecommissionSystemsController'
                },
                'sidebar@systemOwnerReview.authUser.decommissionSystems': {
                    templateUrl: require('./SideBar.tpl.html'),
                    controller: 'SideBarDecommissionSystemsController',
                    resolve: {
                        allSystemTypes: ['businessSystemService', function (service) {
                            return service.getSystemTypes();
                        }]
                    }
                }
            },
            resolve: {
                systemsToReview: ['decommissionSystemsService', '$stateParams', function (service, $stateParams) {
                    return service.getSystemsToToggleSetForDecommission($stateParams.authLogin);
                }]
            }
        })

        // Explanations
        .state('systemOwnerReview.authUser.decommissionSystemsExplanation', {
            url: '/DecommissionSystems_Explanation',
            templateUrl: require('./Explanation1.tpl.html'),
            controller: 'ExplanationDecommissionSystemsController'
        })

        .state('systemOwnerReview.authUser.decommissionSystemsExplanationStep2', {
            url: '/DecommissionSystems_Explanation',
            templateUrl: require('./Explanation2.tpl.html'),
            controller: 'ExplanationDecommissionSystemsController'
        })

        .state('systemOwnerReview.authUser.decommissionSystemsExplanationStep3', {
            url: '/DecommissionSystems_Explanation',
            templateUrl: require('./Explanation3.tpl.html'),
            controller: 'ExplanationDecommissionSystemsController'
        })

        // By System Type
        .state('systemOwnerReview.authUser.decommissionSystems.bySystemType', {
            url: '/{systemTypeSlug}',
            views: {
                'details@systemOwnerReview.authUser.decommissionSystems': {
                    templateUrl: require('./BySystemType.tpl.html'),
                    controller: 'DecommissionSystemsBySystemTypeController',
                    resolve: {
                        systemType: ['businessSystemService', '$stateParams', function (service, $stateParams) {
                            return service.getSystemTypeBySlug($stateParams.systemTypeSlug);
                        }]
                    }
                }
            }
        });
}]);